import { createSlice } from '@reduxjs/toolkit';
import { sar } from '../../../helpers/reduxHelper';

const getInitialState = () => ({
  arePropertiesChanged: false,
  applyMaterialInProgress: false,
  areCameraPropertiesChanged: false
});

const configuratorUnityObjectProperties = createSlice({
  name: 'configuratorUnityObjectProperties',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setApplyMaterialInProgress: sar('applyMaterialInProgress'),
    setArePropertiesChanged: sar('arePropertiesChanged'),
    setAreCameraPropertiesChanged: sar('areCameraPropertiesChanged'),
  },
});

export const configuratorUnityObjectPropertiesActions = configuratorUnityObjectProperties.actions;
export const configuratorUnityObjectPropertiesReducer = configuratorUnityObjectProperties.reducer;
export default configuratorUnityObjectPropertiesReducer;

export const selectApplyMaterialInProgress = (state) =>
  state.configuratorUnityObjectProperties.applyMaterialInProgress;
export const selectArePropertiesChanged = (state) =>
  state.configuratorUnityObjectProperties.arePropertiesChanged;
export const selectAreCameraPropertiesChanged = (state) =>
  state.configuratorUnityObjectProperties.areCameraPropertiesChanged;
